import { Component, h } from 'preact';
import cx from 'classnames'

interface ChoicesButtonGroupProps {
  choices: string[];
  selectedChoice: string;
  disabled?: boolean;

  valid?: boolean;

  onSelect: (choice?: string) => void;
}

export class ChoicesButtonGroup extends Component<ChoicesButtonGroupProps> {
  onSelect(choice: string) {
    const props = this.props;

    if (choice !== this.props.selectedChoice) {
      props.onSelect(choice)
    } else {
      // If the selected choice was clicked again, unselect it
      props.onSelect(null);
    }
  }

  render(props: ChoicesButtonGroupProps) {
    return (
      <div className={ cx('btn-group w-100 hi-choicesbuttongroup', {
        'is-invalid': props.valid === false
      }) }>
        { props.choices.map(choice => (
          <button type="button"
            onClick={ () => this.onSelect(choice) }
            disabled={ props.disabled }
            className={ cx('btn px-1', {
              'btn-dark text-white': choice === props.selectedChoice,
              // We need bg-white and text-dark to override btn-outline-dark's :active styles
              'btn-outline-dark bg-white text-dark': choice !== props.selectedChoice
            }) }
          >
            { choice }
          </button>
        )) }
      </div>
    )
  }
}
